(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumegem-deluxe-bottom-cta"] && !Shopify.designMode) return;
  try {
    
  const initializeLumeGemDeluxeCta = (section) => {
    if (!section || section.dataset.deluxeCtaReady === 'true') return;
    const trigger = section.querySelector('[data-deluxe-buy-target]');
    const target = document.querySelector('.hdt-main-product-form')
      || document.querySelector('product-form')
      || document.querySelector('[data-product-form]')
      || document.querySelector('form[action*="/cart/add"]');
    if (!trigger || !target) return;
    section.dataset.deluxeCtaReady = 'true';
    trigger.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      const focusTarget = target.querySelector('button[name="add"]:not([disabled])')
        || target.querySelector('select:not([disabled])')
        || target.querySelector('input:not([type="hidden"]):not([disabled])')
        || target.querySelector('button:not([disabled])');
      focusTarget?.focus({ preventScroll: true });
    });
  };

  document.querySelectorAll('[data-lumegem-deluxe-cta]').forEach(initializeLumeGemDeluxeCta);
  document.addEventListener('shopify:section:load', (event) => initializeLumeGemDeluxeCta(event.target.querySelector('[data-lumegem-deluxe-cta]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumegem-maker-moments"]) return;
  try {
    
  (() => {
    if (window.__lgMakerMomentsReady) {
      if (window.__lgMakerMomentsInit) {
        window.__lgMakerMomentsInit();
      }
      return;
    }

    window.__lgMakerMomentsReady = true;

    const getModulo = (index, total) => {
      if (!total) return 0;
      return ((index % total) + total) % total;
    };

    const updateStageHeight = (carousel) => {
      const stage = carousel.querySelector('[data-maker-stage]');
      if (!stage) return;

      const visibleCards = Array.from(
        carousel.querySelectorAll('.is-active, .is-prev, .is-next, .is-far-prev, .is-far-next')
      );
      if (!visibleCards.length) return;

      window.requestAnimationFrame(() => {
        const maxCardHeight = visibleCards.reduce((height, card) => {
          return Math.max(height, card.offsetHeight);
        }, 0);

        if (maxCardHeight) {
          carousel.style.setProperty('--lg-maker-stage-auto-height', `${Math.ceil(maxCardHeight + 24)}px`);
        }
      });
    };

    const loadVideo = (video) => {
      if (!video || video.dataset.lgMakerLoaded === 'true') return;

      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.lgMakerLoaded = 'true';
      video.load();
    };

    const updateCarousel = (carousel, nextIndex, shouldPlay) => {
      const cards = Array.from(carousel.querySelectorAll('[data-maker-card]'));
      const dots = Array.from(carousel.parentElement.querySelectorAll('[data-maker-dot]'));
      const total = cards.length;
      if (!total) return;

      const activeIndex = getModulo(nextIndex, total);
      const previousIndex = getModulo(activeIndex - 1, total);
      const nextCardIndex = getModulo(activeIndex + 1, total);
      const farPreviousIndex = getModulo(activeIndex - 2, total);
      const farNextIndex = getModulo(activeIndex + 2, total);

      carousel.dataset.makerActive = String(activeIndex);

      cards.forEach((card, index) => {
        const video = card.querySelector('video');
        card.classList.remove('is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next');

        if (index === activeIndex) {
          card.classList.add('is-active');
          card.removeAttribute('aria-hidden');
          if (video) {
            video.muted = true;
            if (shouldPlay) {
              loadVideo(video);
              video.play().catch(() => {});
            }
          }
        } else {
          card.setAttribute('aria-hidden', 'true');
          if (video) {
            video.pause();
          }

          if (index === previousIndex) {
            card.classList.add('is-prev');
          } else if (index === nextCardIndex) {
            card.classList.add('is-next');
          } else if (index === farPreviousIndex) {
            card.classList.add('is-far-prev');
          } else if (index === farNextIndex) {
            card.classList.add('is-far-next');
          }
        }
      });

      dots.forEach((dot) => {
        dot.classList.toggle('is-active', Number(dot.dataset.makerIndex) === activeIndex);
      });

      updateStageHeight(carousel);
    };

    const setupCarousel = (carousel) => {
      if (carousel.dataset.makerReady === 'true') return;
      carousel.dataset.makerReady = 'true';
      carousel.dataset.makerActive = carousel.dataset.makerActive || '0';

      const stage = carousel.querySelector('[data-maker-stage]');
      const previousButton = carousel.querySelector('[data-maker-prev]');
      const nextButton = carousel.querySelector('[data-maker-next]');
      const dots = Array.from(carousel.parentElement.querySelectorAll('[data-maker-dot]'));
      const cards = Array.from(carousel.querySelectorAll('[data-maker-card]'));

      const moveBy = (step) => {
        const current = Number(carousel.dataset.makerActive || 0);
        updateCarousel(carousel, current + step, false);
      };

      if (previousButton) {
        previousButton.addEventListener('click', () => moveBy(-1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => moveBy(1));
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          updateCarousel(carousel, Number(dot.dataset.makerIndex || 0), false);
        });
      });

      let startX = 0;
      let startY = 0;
      let tracking = false;

      if (stage) {
        stage.addEventListener('pointerdown', (event) => {
        if (event.target.closest('button, input, textarea, select')) return;
        tracking = true;
        startX = event.clientX;
        startY = event.clientY;
        });

        stage.addEventListener('pointerup', (event) => {
        if (!tracking) return;
        tracking = false;
        const diffX = event.clientX - startX;
        const diffY = event.clientY - startY;
        if (Math.abs(diffX) < 42 || Math.abs(diffX) < Math.abs(diffY)) return;
        moveBy(diffX < 0 ? 1 : -1);
        });

        stage.addEventListener('pointercancel', () => {
        tracking = false;
        });
      }

      cards.forEach((card) => {
        card.addEventListener('click', (event) => {
          if (card.classList.contains('is-active')) return;
          event.preventDefault();
          updateCarousel(carousel, Number(card.dataset.makerIndex || 0), false);
        });
      });

      cards.forEach((card) => {
        const video = card.querySelector('video[data-lg-maker-video]');
        if (!video) return;

        video.addEventListener('pointerdown', () => loadVideo(video), { once: true });
        video.addEventListener('play', () => loadVideo(video), { once: true });
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const activeVideo = carousel.querySelector('.is-active video[data-lg-maker-video]');
            loadVideo(activeVideo);
            observer.disconnect();
          });
        }, { rootMargin: '220px 0px' });
        observer.observe(carousel);
      }

      window.addEventListener('resize', () => updateStageHeight(carousel));
      updateCarousel(carousel, Number(carousel.dataset.makerActive || 0), false);
    };

    const initAll = () => {
      document.querySelectorAll('[data-maker-carousel]').forEach(setupCarousel);
    };

    window.__lgMakerMomentsInit = initAll;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-maker-carousel]').forEach(setupCarousel);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const selectedCard = document.querySelector(`[data-maker-block-id="${event.detail.blockId}"]`);
      const carousel = selectedCard ? selectedCard.closest('[data-maker-carousel]') : null;
      if (!selectedCard || !carousel) return;
      updateCarousel(carousel, Number(selectedCard.dataset.makerIndex || 0), false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumegem-pattern-generator"]) return;
  try {
    
  (() => {
    const paletteText = 'A1:FAD8B2:Yellow_A1:LG-BEAD-001|A2:F9CE9C:Yellow_A2:LG-BEAD-002|A3:F7C585:Yellow_A3:LG-BEAD-003|A4:F6BC6F:Yellow_A4:LG-BEAD-004|A5:F4B458:Yellow_A5:LG-BEAD-005|A6:F3AD42:Yellow_A6:LG-BEAD-006|A7:F1A72B:Yellow_A7:LG-BEAD-007|A8:F0A115:Yellow_A8:LG-BEAD-008|A9:DE960E:Yellow_A9:LG-BEAD-009|A10:C88A0D:Yellow_A10:LG-BEAD-010|A11:B17D0B:Yellow_A11:LG-BEAD-011|A12:FAE5B2:Yellow_A12:LG-BEAD-012|A13:F9DE9C:Yellow_A13:LG-BEAD-013|A14:F7D985:Yellow_A14:LG-BEAD-014|A15:F6D46F:Yellow_A15:LG-BEAD-015|A16:F4D058:Yellow_A16:LG-BEAD-016|A17:F3CC42:Yellow_A17:LG-BEAD-017|A18:F1C92B:Yellow_A18:LG-BEAD-018|A19:F0C715:Yellow_A19:LG-BEAD-019|A20:DEBB0E:Yellow_A20:LG-BEAD-020|A21:C8AB0D:Yellow_A21:LG-BEAD-021|A22:B19A0B:Yellow_A22:LG-BEAD-022|A23:FAF1B2:Yellow_A23:LG-BEAD-023|A24:F9EF9C:Yellow_A24:LG-BEAD-024|A25:F7ED85:Yellow_A25:LG-BEAD-025|A26:F6EB6F:Yellow_A26:LG-BEAD-026|B1:C4EEBF:Green_B1:LG-BEAD-027|B2:B0EBA9:Green_B2:LG-BEAD-028|B3:9BEA93:Green_B3:LG-BEAD-029|B4:83E97B:Green_B4:LG-BEAD-030|B5:6AEA63:Green_B5:LG-BEAD-031|B6:65D560:Green_B6:LG-BEAD-032|B7:4BD548:Green_B7:LG-BEAD-033|B8:30D62F:Green_B8:LG-BEAD-034|B9:22CB23:Green_B9:LG-BEAD-035|B10:1ABB1D:Green_B10:LG-BEAD-036|B11:28952C:Green_B11:LG-BEAD-037|B12:BDF0BF:Green_B12:LG-BEAD-038|B13:A7EEAC:Green_B13:LG-BEAD-039|B14:90ED98:Green_B14:LG-BEAD-040|B15:78ED84:Green_B15:LG-BEAD-041|B16:73DA7F:Green_B16:LG-BEAD-042|B17:5BD96C:Green_B17:LG-BEAD-043|B18:43DA59:Green_B18:LG-BEAD-044|B19:29DB47:Green_B19:LG-BEAD-045|B20:1CD03D:Green_B20:LG-BEAD-046|B21:2DA845:Green_B21:LG-BEAD-047|B22:23993C:Green_B22:LG-BEAD-048|B23:BBF2C7:Green_B23:LG-BEAD-049|B24:A4F0B7:Green_B24:LG-BEAD-050|B25:8DEFA7:Green_B25:LG-BEAD-051|B26:86DF9E:Green_B26:LG-BEAD-052|B27:6FDE8F:Green_B27:LG-BEAD-053|B28:57DE80:Green_B28:LG-BEAD-054|B29:3EDF72:Green_B29:LG-BEAD-055|B30:24E164:Green_B30:LG-BEAD-056|B31:32BB62:Green_B31:LG-BEAD-057|B32:28AD59:Green_B32:LG-BEAD-058|C1:E8FFE7:Blue_C1:LG-BEAD-059|C2:A7E7ED:Blue_C2:LG-BEAD-060|C3:90E3EC:Blue_C3:LG-BEAD-061|C4:78DFEC:Blue_C4:LG-BEAD-062|C5:5FDAED:Blue_C5:LG-BEAD-063|C6:5CC6D9:Blue_C6:LG-BEAD-064|C7:43C0D9:Blue_C7:LG-BEAD-065|C8:2ABBDB:Blue_C8:LG-BEAD-066|C9:1DACD0:Blue_C9:LG-BEAD-067|C10:159BBF:Blue_C10:LG-BEAD-068|C11:247E99:Blue_C11:LG-BEAD-069|C12:BBE4F1:Blue_C12:LG-BEAD-070|C13:A5DCF0:Blue_C13:LG-BEAD-071|C14:8DD4EF:Blue_C14:LG-BEAD-072|C15:75CCF0:Blue_C15:LG-BEAD-073|C16:6FBBDD:Blue_C16:LG-BEAD-074|C17:57B2DD:Blue_C17:LG-BEAD-075|C18:3EA8DE:Blue_C18:LG-BEAD-076|C19:249EE0:Blue_C19:LG-BEAD-077|C20:188FD5:Blue_C20:LG-BEAD-078|C21:2879AC:Blue_C21:LG-BEAD-079|C22:206B9D:Blue_C22:LG-BEAD-080|C23:B9DBF3:Blue_C23:LG-BEAD-081|C24:A2CFF2:Blue_C24:LG-BEAD-082|C25:8AC3F2:Blue_C25:LG-BEAD-083|C26:83B5E2:Blue_C26:LG-BEAD-084|C27:6BA8E1:Blue_C27:LG-BEAD-085|C28:539BE2:Blue_C28:LG-BEAD-086|C29:398CE3:Blue_C29:LG-BEAD-087|D1:BFBDEF:Purple_D1:LG-BEAD-088|D2:ABA7ED:Purple_D2:LG-BEAD-089|D3:9790EC:Purple_D3:LG-BEAD-090|D4:8378EC:Purple_D4:LG-BEAD-091|D5:6F5FED:Purple_D5:LG-BEAD-092|D6:6B5CD9:Purple_D6:LG-BEAD-093|D7:5843D9:Purple_D7:LG-BEAD-094|D8:452ADB:Purple_D8:LG-BEAD-095|D9:3C1DD0:Purple_D9:LG-BEAD-096|D10:3515BF:Purple_D10:LG-BEAD-097|D11:3C2499:Purple_D11:LG-BEAD-098|D12:C7BBF1:Purple_D12:LG-BEAD-099|D13:B6A5F0:Purple_D13:LG-BEAD-100|D14:A68DEF:Purple_D14:LG-BEAD-101|D15:9575F0:Purple_D15:LG-BEAD-102|D16:8E6FDD:Purple_D16:LG-BEAD-103|D17:7F57DD:Purple_D17:LG-BEAD-104|D18:703EDE:Purple_D18:LG-BEAD-105|D19:6224E0:Purple_D19:LG-BEAD-106|D20:5918D5:Purple_D20:LG-BEAD-107|D21:5828AC:Purple_D21:LG-BEAD-108|D22:4F209D:Purple_D22:LG-BEAD-109|D23:D0B9F3:Purple_D23:LG-BEAD-110|D24:C3A2F2:Purple_D24:LG-BEAD-111|D25:B68AF2:Purple_D25:LG-BEAD-112|D26:AD83E2:Purple_D26:LG-BEAD-113|E1:F1BCEB:Pink_E1:LG-BEAD-114|E2:EFA6E6:Pink_E2:LG-BEAD-115|E3:EE8EE1:Pink_E3:LG-BEAD-116|E4:EE76DC:Pink_E4:LG-BEAD-117|E5:F05DD6:Pink_E5:LG-BEAD-118|E6:DC59C3:Pink_E6:LG-BEAD-119|E7:DD40BD:Pink_E7:LG-BEAD-120|E8:DF26B6:Pink_E8:LG-BEAD-121|E9:D319A7:Pink_E9:LG-BEAD-122|E10:C31296:Pink_E10:LG-BEAD-123|E11:9C217B:Pink_E11:LG-BEAD-124|E12:F3BAE2:Pink_E12:LG-BEAD-125|E13:F1A3DA:Pink_E13:LG-BEAD-126|E14:F18BD1:Pink_E14:LG-BEAD-127|E15:F273C8:Pink_E15:LG-BEAD-128|E16:E06DB8:Pink_E16:LG-BEAD-129|E17:E054AD:Pink_E17:LG-BEAD-130|E18:E23BA2:Pink_E18:LG-BEAD-131|E19:E42097:Pink_E19:LG-BEAD-132|E20:D91488:Pink_E20:LG-BEAD-133|E21:AF2574:Pink_E21:LG-BEAD-134|E22:A01D66:Pink_E22:LG-BEAD-135|E23:F4B8D9:Pink_E23:LG-BEAD-136|E24:F4A1CC:Pink_E24:LG-BEAD-137|F1:F3BAC9:Red_F1:LG-BEAD-138|F2:F2A3B6:Red_F2:LG-BEAD-139|F3:F18BA3:Red_F3:LG-BEAD-140|F4:F2728E:Red_F4:LG-BEAD-141|F5:F45878:Red_F5:LG-BEAD-142|F6:E1546E:Red_F6:LG-BEAD-143|F7:E23A57:Red_F7:LG-BEAD-144|F8:E5203E:Red_F8:LG-BEAD-145|F9:D9142F:Red_F9:LG-BEAD-146|F10:C80D24:Red_F10:LG-BEAD-147|F11:A01C2A:Red_F11:LG-BEAD-148|F12:F5B8BD:Red_F12:LG-BEAD-149|F13:F4A1A7:Red_F13:LG-BEAD-150|F14:F4888F:Red_F14:LG-BEAD-151|F15:D30022:Red_F15:LG-BEAD-152|F16:E4686C:Red_F16:LG-BEAD-153|F17:E54F51:Red_F17:LG-BEAD-154|F18:E73635:Red_F18:LG-BEAD-155|F19:EA1E1A:Red_F19:LG-BEAD-156|F20:DE160E:Red_F20:LG-BEAD-157|F21:B52820:Red_F21:LG-BEAD-158|F22:A52218:Red_F22:LG-BEAD-159|F23:F6BBB6:Red_F23:LG-BEAD-160|F24:F6A79E:Red_F24:LG-BEAD-161|F25:F79285:Red_F25:LG-BEAD-162|G1:F2C6BA:Orange_G1:LG-BEAD-163|G2:F0B4A4:Orange_G2:LG-BEAD-164|G3:F0A48C:Orange_G3:LG-BEAD-165|G4:F19374:Orange_G4:LG-BEAD-166|G5:F3825A:Orange_G5:LG-BEAD-167|G6:DF7C56:Orange_G6:LG-BEAD-168|G7:E06D3D:Orange_G7:LG-BEAD-169|G8:E25E22:Orange_G8:LG-BEAD-170|G9:D75516:Orange_G9:LG-BEAD-171|G10:C64E0F:Orange_G10:LG-BEAD-172|G11:9F4C1E:Orange_G11:LG-BEAD-173|G12:F4CFB9:Orange_G12:LG-BEAD-174|G13:F3C1A2:Orange_G13:LG-BEAD-175|G14:F3B489:Orange_G14:LG-BEAD-176|G15:F4A870:Orange_G15:LG-BEAD-177|G16:E39F6A:Orange_G16:LG-BEAD-178|G17:E39451:Orange_G17:LG-BEAD-179|G18:E58938:Orange_G18:LG-BEAD-180|G19:E87F1D:Orange_G19:LG-BEAD-181|G20:DC7711:Orange_G20:LG-BEAD-182|G21:B36D22:Orange_G21:LG-BEAD-183|H1:EDEBE9:Neutral_H1:LG-BEAD-184|H2:E7E5E0:Neutral_H2:LG-BEAD-185|H3:E2DFD6:Neutral_H3:LG-BEAD-186|H4:DED9CC:Neutral_H4:LG-BEAD-187|H5:D3D0C9:Neutral_H5:LG-BEAD-188|H6:CEC9BF:Neutral_H6:LG-BEAD-189|H7:CAC3B5:Neutral_H7:LG-BEAD-190|H8:C7BEAA:Neutral_H8:LG-BEAD-191|H9:B9B5A9:Neutral_H9:LG-BEAD-192|H10:B5B09E:Neutral_H10:LG-BEAD-193|H11:B2A793:Neutral_H11:LG-BEAD-194|H12:B0A287:Neutral_H12:LG-BEAD-195|H13:9F998A:Neutral_H13:LG-BEAD-196|H14:9D947E:Neutral_H14:LG-BEAD-197|H15:9B9171:Neutral_H15:LG-BEAD-198|H16:998665:Neutral_H16:LG-BEAD-199|H17:847C6C:Neutral_H17:LG-BEAD-200|H18:807761:Neutral_H18:LG-BEAD-201|H19:7B7257:Neutral_H19:LG-BEAD-202|H20:766D4E:Neutral_H20:LG-BEAD-203|H21:645D52:Neutral_H21:LG-BEAD-204|H22:5F5748:Neutral_H22:LG-BEAD-205|H23:5A523F:Neutral_H23:LG-BEAD-206|M1:EEEBE7:Neutral_M1:LG-BEAD-207|M2:E5E0D9:Neutral_M2:LG-BEAD-208|M3:DED5CA:Neutral_M3:LG-BEAD-209|M4:D7CCBA:Neutral_M4:LG-BEAD-210|M5:C8C0B3:Neutral_M5:LG-BEAD-211|M6:C1B2A3:Neutral_M6:LG-BEAD-212|M7:BBA893:Neutral_M7:LG-BEAD-213|M8:B69F81:Neutral_M8:LG-BEAD-214|M9:A2947F:Neutral_M9:LG-BEAD-215|M10:9D8B6D:Neutral_M10:LG-BEAD-216|M11:967A5E:Neutral_M11:LG-BEAD-217|M12:8C7051:Neutral_M12:LG-BEAD-218|M13:736553:Neutral_M13:LG-BEAD-219|M14:695B47:Neutral_M14:LG-BEAD-220|M15:5E513B:Neutral_M15:LG-BEAD-221|P1:DABFEE:Purple_P1:LG-BEAD-222|P2:D1A9EB:Purple_P2:LG-BEAD-223|P3:C893EA:Purple_P3:LG-BEAD-224|P4:C17BE9:Purple_P4:LG-BEAD-225|P5:BA63EA:Purple_P5:LG-BEAD-226|P6:AD60D5:Purple_P6:LG-BEAD-227|P7:A848D5:Purple_P7:LG-BEAD-228|P8:A32FD6:Purple_P8:LG-BEAD-229|P9:9A22CB:Purple_P9:LG-BEAD-230|P10:8F1ABB:Purple_P10:LG-BEAD-231|P11:792895:Purple_P11:LG-BEAD-232|P12:E3BDF0:Purple_P12:LG-BEAD-233|P13:DEA7EE:Purple_P13:LG-BEAD-234|P14:D990ED:Purple_P14:LG-BEAD-235|P15:D678ED:Purple_P15:LG-BEAD-236|P16:C773DA:Purple_P16:LG-BEAD-237|P17:C55BD9:Purple_P17:LG-BEAD-238|P18:C443DA:Purple_P18:LG-BEAD-239|P19:C429DB:Purple_P19:LG-BEAD-240|P20:BC1CD0:Purple_P20:LG-BEAD-241|P21:9C2DA8:Purple_P21:LG-BEAD-242|P22:902399:Purple_P22:LG-BEAD-243|P23:EEBBF2:Purple_P23:LG-BEAD-244|Q1:F8EDB5:Yellow_Q1:LG-BEAD-245|Q2:F8EB9D:Yellow_Q2:LG-BEAD-246|Q3:F7E985:Yellow_Q3:LG-BEAD-247|R1:BDEFC7:Green_R1:LG-BEAD-248|R2:A7EDB7:Green_R2:LG-BEAD-249|R3:90ECA6:Green_R3:LG-BEAD-250|R4:78EC95:Green_R4:LG-BEAD-251|R5:5FED85:Green_R5:LG-BEAD-252|R6:5CD97F:Green_R6:LG-BEAD-253|R7:43D970:Green_R7:LG-BEAD-254|R8:2ADB61:Green_R8:LG-BEAD-255|R9:1DD058:Green_R9:LG-BEAD-256|R10:15BF50:Green_R10:LG-BEAD-257|R11:24994E:Green_R11:LG-BEAD-258|R12:BBF1D0:Green_R12:LG-BEAD-259|R13:A5F0C2:Green_R13:LG-BEAD-260|R14:8DEFB5:Green_R14:LG-BEAD-261|R15:75F0A9:Green_R15:LG-BEAD-262|R16:6FDDA0:Green_R16:LG-BEAD-263|R17:57DD95:Green_R17:LG-BEAD-264|R18:3EDE8A:Green_R18:LG-BEAD-265|R19:24E080:Green_R19:LG-BEAD-266|R20:18D577:Green_R20:LG-BEAD-267|R21:28AC6D:Green_R21:LG-BEAD-268|R22:209D63:Green_R22:LG-BEAD-269|R23:B9F3D9:Green_R23:LG-BEAD-270|R24:A2F2D0:Green_R24:LG-BEAD-271|R25:8AF2C7:Green_R25:LG-BEAD-272|R26:83E2BC:Green_R26:LG-BEAD-273|R27:6BE1B4:Green_R27:LG-BEAD-274|R28:53E2AD:Green_R28:LG-BEAD-275|R29:39E3A7:Green_R29:LG-BEAD-276';
    const palette = paletteText.split('|').map((item) => {
      const parts = item.split(':');
      const hex = `#${parts[1]}`;
      const rgb = hexToRgb(hex);
      return { code: parts[0], hex, name: parts[2].replace(/_/g, ' '), sku: parts[3], rgb };
    });

    function hexToRgb(hex) {
      const value = hex.replace('#', '');
      return {
        r: parseInt(value.slice(0, 2), 16),
        g: parseInt(value.slice(2, 4), 16),
        b: parseInt(value.slice(4, 6), 16),
      };
    }

    function nearestColor(r, g, b) {
      let best = palette[0];
      let bestScore = Infinity;
      palette.forEach((color) => {
        const dr = r - color.rgb.r;
        const dg = g - color.rgb.g;
        const db = b - color.rgb.b;
        const score = (dr * dr * .3) + (dg * dg * .59) + (db * db * .11);
        if (score < bestScore) {
          bestScore = score;
          best = color;
        }
      });
      return best;
    }

    function colorDistance(a, b) {
      const dr = a.r - b.r;
      const dg = a.g - b.g;
      const db = a.b - b.b;
      return Math.sqrt((dr * dr) + (dg * dg) + (db * db));
    }

    function averageColor(colors) {
      const total = colors.reduce((sum, color) => ({
        r: sum.r + color.r,
        g: sum.g + color.g,
        b: sum.b + color.b,
      }), { r: 0, g: 0, b: 0 });
      return {
        r: total.r / colors.length,
        g: total.g / colors.length,
        b: total.b / colors.length,
      };
    }

    function drawBead(ctx, x, y, size, hex) {
      if (size < 7) {
        ctx.fillStyle = hex;
        ctx.fillRect(x, y, size, size);
        return;
      }
      const radius = Math.max(1.6, (size * .42));
      const centerX = x + (size / 2);
      const centerY = y + (size / 2);
      const gradient = ctx.createRadialGradient(centerX - (size * .16), centerY - (size * .18), size * .08, centerX, centerY, radius);
      gradient.addColorStop(0, '#fff8ed');
      gradient.addColorStop(.18, hex);
      gradient.addColorStop(1, hex);
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = 'rgba(21, 17, 15, .18)';
      ctx.beginPath();
      ctx.arc(centerX, centerY, Math.max(1, size * .12), 0, Math.PI * 2);
      ctx.fill();
    }

    function prepareCanvas(canvas, fallbackWidth, fallbackHeight) {
      const rect = canvas.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, 2.5);
      const width = Math.max(fallbackWidth, Math.round((rect.width || fallbackWidth) * ratio));
      const height = Math.max(fallbackHeight, Math.round((rect.height || fallbackHeight) * ratio));
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
      }
      return canvas.getContext('2d', { willReadFrequently: true });
    }

    function drawEmpty(canvas, text) {
      const ctx = prepareCanvas(canvas, 720, 560);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#fff7ee';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#6f675f';
      ctx.font = `${Math.max(16, Math.round(canvas.width / 30))}px system-ui, sans-serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, canvas.width / 2, canvas.height / 2);
    }

    function downloadBlob(content, type, filename) {
      const blob = content instanceof Blob ? content : new Blob([content], { type });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    }

    document.querySelectorAll('[data-lg-pattern-maker]').forEach((tool) => {
      const input = tool.querySelector('.lg-pattern-maker__input');
      const sizeSelect = tool.querySelector('.lg-pattern-maker__size');
      const gridSelect = tool.querySelector('.lg-pattern-maker__grid');
      const backgroundSelect = tool.querySelector('.lg-pattern-maker__background');
      const originalCanvas = tool.querySelector('.lg-pattern-maker__original');
      const patternCanvas = tool.querySelector('.lg-pattern-maker__pattern');
      const totalNode = tool.querySelector('.lg-pattern-maker__total');
      const colorsNode = tool.querySelector('.lg-pattern-maker__colors');
      const swatchesNode = tool.querySelector('.lg-pattern-maker__swatches');
      const pngButton = tool.querySelector('.lg-pattern-maker__download-png');
      const csvButton = tool.querySelector('.lg-pattern-maker__download-csv');
      let currentImage = null;
      let currentCells = [];
      let currentCounts = [];

      const redraw = () => {
        if (currentImage) {
          drawOriginal();
          drawPattern();
          return;
        }
        drawEmpty(originalCanvas, 'Upload an image');
        drawEmpty(patternCanvas, 'Pattern preview');
      };

      drawEmpty(originalCanvas, 'Upload an image');
      drawEmpty(patternCanvas, 'Pattern preview');
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(redraw);
        observer.observe(originalCanvas);
        observer.observe(patternCanvas);
      }

      function render() {
        if (!currentImage) {
          return;
        }

        const targetWidth = parseInt(sizeSelect.value, 10);
        const targetHeight = Math.max(1, Math.round(targetWidth * currentImage.height / currentImage.width));
        const source = document.createElement('canvas');
        source.width = targetWidth;
        source.height = targetHeight;
        const sourceCtx = source.getContext('2d', { willReadFrequently: true });
        sourceCtx.drawImage(currentImage, 0, 0, targetWidth, targetHeight);
        const data = sourceCtx.getImageData(0, 0, targetWidth, targetHeight).data;
        const cornerPixels = [
          { r: data[0], g: data[1], b: data[2] },
          {
            r: data[((targetWidth - 1) * 4)],
            g: data[((targetWidth - 1) * 4) + 1],
            b: data[((targetWidth - 1) * 4) + 2],
          },
          {
            r: data[((targetHeight - 1) * targetWidth * 4)],
            g: data[((targetHeight - 1) * targetWidth * 4) + 1],
            b: data[((targetHeight - 1) * targetWidth * 4) + 2],
          },
          {
            r: data[(((targetHeight - 1) * targetWidth) + targetWidth - 1) * 4],
            g: data[((((targetHeight - 1) * targetWidth) + targetWidth - 1) * 4) + 1],
            b: data[((((targetHeight - 1) * targetWidth) + targetWidth - 1) * 4) + 2],
          },
        ];
        const backgroundColor = averageColor(cornerPixels);
        const removeBackground = backgroundSelect.value === 'remove';
        const backgroundTolerance = 54;
        const counts = new Map();
        const cells = [];

        for (let y = 0; y < targetHeight; y += 1) {
          const row = [];
          for (let x = 0; x < targetWidth; x += 1) {
            const index = (y * targetWidth + x) * 4;
            const pixel = { r: data[index], g: data[index + 1], b: data[index + 2] };
            if (removeBackground && colorDistance(pixel, backgroundColor) < backgroundTolerance) {
              row.push(null);
              continue;
            }
            const match = nearestColor(pixel.r, pixel.g, pixel.b);
            row.push(match);
            counts.set(match.code, (counts.get(match.code) || 0) + 1);
          }
          cells.push(row);
        }

        currentCells = cells;
        currentCounts = Array.from(counts.entries()).map(([code, count]) => {
          const color = palette.find((item) => item.code === code);
          return { ...color, count };
        }).sort((a, b) => b.count - a.count);

        drawOriginal();
        drawPattern();
        updateSummary();
      }

      function drawOriginal() {
        const ctx = prepareCanvas(originalCanvas, 720, 560);
        ctx.clearRect(0, 0, originalCanvas.width, originalCanvas.height);
        ctx.fillStyle = '#fff7ee';
        ctx.fillRect(0, 0, originalCanvas.width, originalCanvas.height);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        const scale = Math.min(originalCanvas.width / currentImage.width, originalCanvas.height / currentImage.height);
        const width = currentImage.width * scale;
        const height = currentImage.height * scale;
        ctx.drawImage(currentImage, (originalCanvas.width - width) / 2, (originalCanvas.height - height) / 2, width, height);
      }

      function paintPattern(ctx, cellSize, offsetX, offsetY, showGrid) {
        const width = currentCells[0].length;
        const height = currentCells.length;
        const patternWidth = width * cellSize;
        const patternHeight = height * cellSize;

        ctx.imageSmoothingEnabled = false;
        currentCells.forEach((row, y) => {
          row.forEach((color, x) => {
            if (!color) {
              return;
            }
            drawBead(ctx, offsetX + (x * cellSize), offsetY + (y * cellSize), cellSize, color.hex);
          });
        });

        if (showGrid && cellSize >= 5) {
          ctx.strokeStyle = 'rgba(23, 21, 18, .18)';
          ctx.lineWidth = 1;
          for (let x = 0; x <= width; x += 1) {
            ctx.beginPath();
            ctx.moveTo(offsetX + (x * cellSize) + .5, offsetY);
            ctx.lineTo(offsetX + (x * cellSize) + .5, offsetY + patternHeight);
            ctx.stroke();
          }
          for (let y = 0; y <= height; y += 1) {
            ctx.beginPath();
            ctx.moveTo(offsetX, offsetY + (y * cellSize) + .5);
            ctx.lineTo(offsetX + patternWidth, offsetY + (y * cellSize) + .5);
            ctx.stroke();
          }
        }
      }

      function drawPattern() {
        if (!currentCells.length) {
          return;
        }
        const showGrid = gridSelect.value === 'on';
        const width = currentCells[0].length;
        const height = currentCells.length;
        const ctx = prepareCanvas(patternCanvas, 900, 700);
        const cellSize = Math.max(2, Math.floor(Math.min(patternCanvas.width / width, patternCanvas.height / height)));
        const patternWidth = width * cellSize;
        const patternHeight = height * cellSize;
        const offsetX = Math.floor((patternCanvas.width - patternWidth) / 2);
        const offsetY = Math.floor((patternCanvas.height - patternHeight) / 2);
        ctx.clearRect(0, 0, patternCanvas.width, patternCanvas.height);
        ctx.fillStyle = '#fff7ee';
        ctx.fillRect(0, 0, patternCanvas.width, patternCanvas.height);
        paintPattern(ctx, cellSize, offsetX, offsetY, showGrid);
      }

      function createExportCanvas() {
        const showGrid = gridSelect.value === 'on';
        const cellSize = 28;
        const width = currentCells[0].length;
        const height = currentCells.length;
        const exportCanvas = document.createElement('canvas');
        exportCanvas.width = width * cellSize;
        exportCanvas.height = height * cellSize;
        const ctx = exportCanvas.getContext('2d');
        ctx.fillStyle = '#fff7ee';
        ctx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);
        paintPattern(ctx, cellSize, 0, 0, showGrid);
        return exportCanvas;
      }

      function updateSummary() {
        const total = currentCounts.reduce((sum, item) => sum + item.count, 0);
        totalNode.textContent = String(total);
        colorsNode.textContent = String(currentCounts.length);
        swatchesNode.innerHTML = currentCounts.slice(0, 24).map((item) => (
          `<div class="lg-pattern-maker__swatch"><i style="background:${item.hex}"></i><span>${item.code} - ${item.name}</span><b>${item.count}</b></div>`
        )).join('');
        pngButton.disabled = false;
        csvButton.disabled = false;
      }

      function patternCsv() {
        const rows = ['code,name,sku,hex,count'];
        currentCounts.forEach((item) => {
          rows.push([item.code, item.name, item.sku, item.hex, item.count].join(','));
        });
        rows.push('');
        rows.push('pattern_grid');
        currentCells.forEach((row) => {
          rows.push(row.map((cell) => cell ? cell.code : '').join(','));
        });
        return rows.join(String.fromCharCode(10));
      }

      input.addEventListener('change', () => {
        const file = input.files && input.files[0];
        if (!file) {
          return;
        }
        const img = new Image();
        img.onload = () => {
          currentImage = img;
          render();
          URL.revokeObjectURL(img.src);
        };
        img.src = URL.createObjectURL(file);
      });

      sizeSelect.addEventListener('change', render);
      gridSelect.addEventListener('change', drawPattern);
      backgroundSelect.addEventListener('change', render);
      pngButton.addEventListener('click', () => {
        if (!currentCells.length) {
          return;
        }
        createExportCanvas().toBlob((blob) => {
          if (blob) {
            downloadBlob(blob, 'image/png', 'lumegem-bead-pattern.png');
          }
        }, 'image/png');
      });
      csvButton.addEventListener('click', () => {
        downloadBlob(patternCsv(), 'text/csv;charset=utf-8', 'lumegem-bead-counts.csv');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumegem-support-blocks"]) return;
  try {
    
  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-lg-track-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('[data-lg-tracking-number]');
    var error = form.querySelector('[data-lg-track-error]');
    var value = input ? input.value.trim() : '';
    if (!value) {
      if (error) error.style.display = 'block';
      if (input) input.focus();
      return;
    }
    if (error) error.style.display = 'none';
    window.open('https://www.17track.net/en/tracking?nums=' + encodeURIComponent(value.replace(/\s+/g, '')), '_blank', 'noopener');
  });

  } catch(e) { console.error(e); }
})();
})();
